module.exports = __webpack_public_path__ + "img/monarch-ui-icon_HOMOLOG.ce2c8924.png";